import { useEffect } from 'react';
import useAuthStore from '@pkg/auth/useStore';
import Database from '@pkg/database/Database';
import useMutations from './useMutations';
import useRefresh from './useRefresh';
import useStore from './useStore';

export default function useLive() {
  const { isAuthenticated, isLoading } = useAuthStore();
  const { refresh, isRefreshing } = useRefresh();
  const { setProperties, setLoading, setMutations } = useStore();
  const mutations = useMutations();

  const isStale = Database.useStaleHash('properties');
  const properties = Database.useLive('properties');

  useEffect(() => {
    if (isLoading || isRefreshing) {
      return;
    }

    if (!isAuthenticated) {
      setProperties([]);
      setLoading(false);
      return;
    }

    if (isStale) {
      refresh();
      return;
    }

    if (!properties) {
      return;
    }

    setProperties(properties);
    setLoading(false);
  }, [properties, isAuthenticated, isLoading, isRefreshing, isStale]);

  useEffect(() => {
    setMutations(isAuthenticated ? mutations : {});
  }, [isAuthenticated, mutations]);
}
